import { LayoutApiRequestData } from '../../types/types';

// Builds the JSONata resolving input for layout apiMethods (fills {{ id }} etc.).
export const getLayoutApiRequestData = (
  objectId: string,
  token: string | null,
  datasetId: string
): LayoutApiRequestData => ({
  datasetId: datasetId || '',
  sessionId: token || '',
  id: objectId,
});
